import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import NotImplemented from '../components/NotImplemented';

export default function Summary() {
	usePageTitle('sitio.enConstruccion');

	return (
		<NotImplemented></NotImplemented>
	);
}
